<template>
  <div class="popup-cotainer">
    <div
      v-show="visible"
      class="popup-mask tw-overlay"
      @click="maskClick"
    />
    <transition
      :name="type"
      @after-enter="onAfterEnter"
    >
      <div
        v-show="visible"
        class="popup-wrap"
        :class="type"
      >
        <slot name="close">
          <div
            v-if="showClose"
            class="close-btn"
            @click="close"
          >
            <svg
              class="icon icon-close"
              viewBox="0 0 1024 1024"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M551.822 512L870.4 193.422c11.378-11.378 11.378-28.444 0-39.822s-28.444-11.378-39.822 0L512 472.178 193.422 147.91c-11.378-11.378-28.444-11.378-39.822 0s-11.378 28.445 0 39.822L472.178 512 153.6 830.578c-11.378 11.378-11.378 28.444 0 39.822 5.689 5.689 11.378 5.689 22.756 5.689s17.066 0 22.755-5.689L512 551.822 830.578 870.4c5.689 5.689 11.378 5.689 22.755 5.689s17.067 0 22.756-5.689c11.378-11.378 11.378-28.444 0-39.822L551.822 512z"
              />
            </svg>
          </div>
        </slot>
        <slot />
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'VPopup',
  model: {
    prop: 'visible',
    event: 'close'
  },
  props: {
    type: {
      type: String,
      default: 'popup-bottom'
    },
    visible: {
      type: Boolean,
      default: false
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true
    },
    // 是否可通过点击遮罩关闭
    closeOnClickModal: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onAfterEnter() {
      this.$emit('after-enter')
    },
    close() {
      this.$emit('close', false)
    },
    maskClick() {
      if (!this.closeOnClickModal) return
      this.$emit('close', false)
    }
  }
}
</script>
<style lang="less">
.popup-cotainer {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
}

.popup-mask {
  z-index: 1000;
}

.popup-wrap {
  position: fixed;
  z-index: 2000;
  background-color: #fff;
  text-align: center;

  .close-btn {
    position: absolute;
    z-index: 9;
    top: 0;
    right: 0;
    width: 44px;
    height: 44px;
    text-align: center;

    .icon {
      width: 18px;
      height: 100%;
      fill: #999;
    }
  }
}

.popup-bottom {
  bottom: 0;
  left: 0;
  width: 100%;
  border-radius: 16px 16px 0 0;
}

.popup-top {
  top: 0;
  left: 0;
  width: 100%;
}

.popup-left {
  top: 0;
  left: 0;
  height: 100%;
}

.popup-right {
  top: 0;
  right: 0;
  height: 100%;
}

.popup-bottom-enter-active,
.popup-bottom-leave-active,
.popup-top-enter-active,
.popup-top-leave-active,
.popup-left-enter-active,
.popup-left-leave-active,
.popup-right-enter-active,
.popup-right-leave-active {
  transition: all 0.3s ease;
}

.popup-bottom-enter,
.popup-bottom-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

.popup-top-enter,
.popup-top-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}

.popup-left-enter,
.popup-left-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.popup-right-enter,
.popup-right-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
